import { Card } from "@arcadeai/design-system/components/ui/atoms/card";
import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import { cn } from "@arcadeai/design-system/lib/utils";

type InvitationCardSkeletonProps = {
  className?: string;
};

export function InvitationCardSkeleton({
  className,
}: InvitationCardSkeletonProps) {
  return (
    <Card
      className={cn(
        "overflow-hidden border-muted bg-muted/30 py-1 dark:bg-muted/10",
        className
      )}
    >
      <div className="space-y-4 p-4">
        {/* Header Section */}
        <div className="flex items-start justify-between gap-3">
          <div className="flex-1 space-y-2">
            <Skeleton className="h-5 w-3/4" />
            <Skeleton className="h-4 w-1/2" />
          </div>
          <Skeleton className="h-5 w-20 shrink-0" />
        </div>

        {/* Inviters List */}
        <div className="space-y-3 rounded-lg border bg-background p-3 shadow-sm">
          <Skeleton className="h-3 w-24" />
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
              <div className="min-w-0 flex-1 space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-48" />
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-8 w-8 shrink-0 rounded-full" />
              <div className="min-w-0 flex-1 space-y-2">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-48" />
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="grid grid-cols-2 gap-3 pt-1">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>
    </Card>
  );
}
